import { StaticImageData } from "next/image";
import { questionType } from "../courses/types";

export interface chatType {
  messageID: string; //Message
  userId: string; //Chat
  text: string; //Message.content
  isMe: boolean;
  date: number; //Message.timestamp
}

export interface contactType {
  userId: string; //user Friendship
  name: string; //user
  profileImg?: string | StaticImageData; //user
  status: string; //user
  lastMessageTimestamp: Date;
  lastMessage: string; //Chat
  messageInTextarea?: string;
  isFriend: boolean; //Friendship
  requested?: boolean; //Friendship
}

export interface BackendUserType {
  id: string;
  userId: string;
  name: string;
  email?: string;
  isRestrictedChildAccount?: boolean;
  associatedChildNames?: string[];
  relationShip?: number;
  profileImg?: string | StaticImageData;
  hasNewMessages?: boolean;
  hasUnreadConversation?: boolean;
  unreadConversationCount?: number;
  isNew?: boolean;
  status?: number;
  lastMessage?: string;
  lastMessageTimestamp?: Date;
  isSystem?: boolean;
}

export interface Friendship {
  id: string;
  fromUserId: string;
  toUserId: string;
  fromName: string;
  fromEmail?: string;
  toName: string;
  toEmail?: string;
  createdDate: Date;
  lastUpdatedDate?: Date;
  status: number;
  invitationTypeId?: number;
  isJoinRequest?: boolean;
  courseId?: string;
  courseTitle?: string;
}

export interface ManagedChildInvitation {
  childUserId: string;
  childName: string;
  childEmail?: string;
  isFirstParentDecisionRequired: boolean;
  invitation: Friendship;
}

export enum InvitationTypeEnum {
  Contact = 0,
  Classroom = 1,
  ParentChild = 2,
}
export interface ScoreMessage {
  id: string;
  from: string;
  raceId: string;
  isCorrect: string;
}

export interface PlayerType {
  playerId: string;
  playerName: string;
  isHost: boolean;
  isConfirmed: boolean;
  score: number;
}

export interface Race {
  name: string;
  gameId: string;
  creatorId: string;
  startTime?: Date;
  endTime?: Date;
  players: PlayerType[];
  hasStarted: boolean;
  isFinished: boolean;
}

export interface Message {
  id: string;
  from: string;
  to: string;
  text: string;
  date: Date;
  type?: number;
  action?: string;
  bookingId?: string;
  bookingTitle?: string;
  bookingStartUtc?: string;
  participantUserId?: string;
  applyToSeries?: string;
}

export interface Chat {
  userId: string; // The other user's ID
  // lastMessage?: Message;
  chatId: string;
  messages: Message[];
  messageInTextarea?: string;
}

export interface MessageUserFriends {
  userID: string;
} 

export enum ContactStatusEnum 
    {
        Accepted = 0,
        Waiting = 1,
        Cancelled = 2,
        Rejected = 3,
        Expired = 4,
        Blocked = 5
    }

export enum PushNotificationTypeEnum
    {
        InvitationAccepted,
        InvitationReceived,
        NewMessage,
        NewBattleRequest,
        ScoreUpdate,
        BattleStarted,
        InvitationUpdated,
    BookingReceived,
    BookingParticipantCancelled,
    BookingParticipantUpdated
    }
     